<template>
  <div class="container-fluid full-width-page-wrapper">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="font-weight-bold page-title mb-0">My Nominations</h3>

      <ifac-search-dropdown
        scope="button"
        v-if="awards.length > 0"
        class="m-0"
        style="width: 210px;"
        :options="itemsAwards"
        placeholder="Create new nomination"
        @selected="goToCreate"
      ></ifac-search-dropdown>

      <div v-if="awards.length === 0">
        <b-button variant="primary" disabled>Award nominations are currently closed</b-button>
      </div>
    </div>

    <div class="mt-2">
      <NominationsTable/>
    </div>
  </div>
</template>

<script>
import NominationsTable from '@/views/areas/awards//nominations/partials/NominationsTable.vue';
import { IfacSearchDropdown } from '@ifac/ui';
import Awards from '@/services/Api/Awards/Awards';

export default {
  name: 'Awards',
  components: {
    IfacSearchDropdown,
    NominationsTable,
  },
  data() {
    return {
      selectedAward: null,
      awards: [],
    };
  },
  created() {
    const params = {
      scopes: ['open'],
    };
    Awards.all(params).then((response) => {
      this.awards = response.data.data;
    });
  },
  methods: {
    goToCreate(award) {
      if (award) {
        this.$router.push({
          name: 'NominationsCreate',
          params: {
            award: award.id,
          },
        });
      }
    },
  },
  computed: {
    itemsAwards() {
      return this.awards.map((award) => ({
          id: award.id,
          name: award.name,
        }));
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/base/_variables.scss';
@import '@/assets/styles/base/_mixins.scss';
</style>
